module.exports = __webpack_public_path__ + "static/media/image-2.8172fb25.svg";